interface ControlData {
  specificity?: number;
  [key: string]: any;
}

interface TestData {
  Test: string;
}

const updateFunc = (controlData: ControlData): TestData[] => {
  const specificity =
    controlData["specificity"] !== undefined ? controlData["specificity"] : 95;

  const fp = 100 - specificity;
  const tn = specificity;
  const bl = 900;

  const jsonTrueNegative: TestData = { Test: "True negative" };
  const jsonFalsePositive: TestData = { Test: "False positive" };
  const jsonBlank: TestData = { Test: "" };
  const repeatedTrueNegative = Array(tn).fill(jsonTrueNegative);
  const repeatedFalsePositive = Array(fp).fill(jsonFalsePositive);
  const repeatedBlank = Array(bl).fill(jsonBlank);
  const calculatedData1 = repeatedTrueNegative.concat(repeatedFalsePositive);
  const calculatedData = calculatedData1.concat(repeatedBlank);

  return calculatedData;
};

export default updateFunc;
